import { RESET_PASSWORD_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class ResetPasswordError extends ApiError {
  constructor() {
    super(RESET_PASSWORD_ERROR);
  }
}
